<template>
    <div class="parent pa-3">
        <div class="pa-2">
            <v-icon color="yellow">mdi-alert</v-icon>
        </div>
        <div class="pl-2">
            <slot></slot>
        </div>
    </div>
</template>

<script>

    export default {

        components: {},

        props: {
            type: {
                type: String,
                required: true,
                validator: (value) => ['info', 'warning', 'error'].includes(value),
                default: 'info'
            }
        },

        computed: {
            icon() {
                if (this.type ==='warning') return 'mdi-alert';
                if (this.type ==='info') return 'mdi-info';
                if (this.type ==='error') return 'mdi-error';
            }
        },
    }
</script>

<style scoped>

    .parent {
        display: flex;
        align-items: center;
    }

</style>
